import React, {useEffect, useState} from "react";

import ShapeColorPicker from "./ShapeColorPicker";
import {Tooltip} from "react-tooltip";
import {useAuth} from "../../../providers/AuthProvider";


export default function ShapeToolbar(props) {
    const {user} = useAuth();

    const [colorPickerVisible, setColorPickerVisible] = useState(false);
    const [color, setColor] = useState(props.data.geoJSON && props.data.geoJSON.properties && props.data.geoJSON.properties.color ? props.data.geoJSON.properties.color : null);

    let baseUnion = true;
    if (props.data && props.data.geoJSON && props.data.geoJSON.properties && props.data.geoJSON.properties.union === false) {
        baseUnion = false;
    }
    const [union, setUnion] = useState(baseUnion);

    let baseVisible = true;
    if (props.data && props.data.geoJSON && props.data.geoJSON.properties && props.data.geoJSON.properties.visible === false) {
        baseVisible = false;
    }
    const [visible, setVisible] = useState(baseVisible);

    let basePopupTitle = false;
    if (props.data && props.data.geoJSON && props.data.geoJSON.properties && props.data.geoJSON.properties.popupTitle) {
        basePopupTitle = true;
    }
    const [popupTitle, setPopupTitle] = useState(basePopupTitle);

    let baseClusterified = true;
    if (props.data.geoJSON && props.data.geoJSON.properties && (props.data.geoJSON.properties.clusterified === false)) {
        baseClusterified = false;
    }
    const [clusterified, setClusterified] = useState(baseClusterified);



    useEffect(() => {
        setColor(props.data.geoJSON && props.data.geoJSON.properties && props.data.geoJSON.properties.color ? props.data.geoJSON.properties.color : null);
        setPopupTitle(!!(props.data.geoJSON && props.data.geoJSON.properties && props.data.geoJSON.properties.popupTitle));

        let baseUnion = true;
        if (props.data.geoJSON && props.data.geoJSON.properties && props.data.geoJSON.properties.union === false) {
            baseUnion = false;
        }
        setUnion(baseUnion);

        let baseClusterified = true;
        if (props.data.geoJSON && props.data.geoJSON.properties && (props.data.geoJSON.properties.clusterified === false)) {
            baseClusterified = false;
        }
        setClusterified(baseClusterified);
    }, [props.data.geoJSON]);


    const onToggleUnion = (e) => {
        e.preventDefault();

        setUnion(!union);
        props.onToggleUnion();
    }


    const onEditNotes = (e) => {
        e.preventDefault();

        props.onEditNotes(true);
    }


    const onRemove = (e) => {
        e.preventDefault();

        props.onRemove();
    }


    const onMinimizePanel = (e) => {
        e.preventDefault();

        props.onMinimizePanel(e);
    }


    const onSaveToFilesClick = (e) => {
        e.preventDefault();

        props.onSaveToFiles();
    }


    const onPinsVisibleClick = (e) => {
        e.preventDefault();

        props.onPinsVisibleChange(!props.pinsVisible);
    }


    const onLayerToTopClick = (e) => {
        e.preventDefault();

        props.onLayerToTop();
    }


    const onLayerToBottomClick = (e) => {
        e.preventDefault();

        props.onLayerToBottom();
    }


    const onToggleVisible = (e) => {
        e.preventDefault();

        setVisible(!visible);
        props.onToggleVisible(!visible);
    }


    const onToggleClusterified = (e) => {
        e.preventDefault();

        if (props.onToggleClusterified) {
            setClusterified(!clusterified);
            props.onToggleClusterified();
        }
    }


    const onColorClick = (e) => {
        e.preventDefault();

        setColorPickerVisible(!colorPickerVisible);
    }


    const onColorChange = (color, event) => {
        setColor(color);
    }


    const onTogglePopupTitle = (e) => {
        e.preventDefault();

        setPopupTitle(!popupTitle);
        props.onTogglePopupTitle(!popupTitle);
    }


    const onColorChangeComplete = (color, event) => {
        props.onColorChange(color);

        setColorPickerVisible(false);
    }


    const onConvertShape = (e) => {
        e.preventDefault();

        props.onConvertShape(props.id, 'reference');
    }


    let colorPickerStyle = {height: '7px', width: '7px', borderRadius: '7px'};
    if (color) {
        colorPickerStyle = {...colorPickerStyle, backgroundColor: color, display: 'block'};
    }


    return (
        <>
            <div className="btn-group flex-column justify-content-between shape-toolbar">
                <button onClick={onMinimizePanel} className={'btn border-0 p-2 mx-1 d-flex align-items-center'}>
                    <i className={'ti ti-arrows-diagonal-minimize-2 fs-4'}></i>
                    <span className={'fs-2 ms-2'}>Minimize Panel</span>
                </button>

                <hr className="my-2"/>

                {props.data.type !== 'Marker' ? (<>
                <button onClick={onPinsVisibleClick} className={'btn border-0 p-2 mx-1 d-flex align-items-center'}>
                    <i className={'ti fs-4 ' + (props.pinsVisible ? 'ti-map-pin-off' : 'ti-map-pin')}></i>
                    <span className={'fs-2 ms-2'}>{props.pinsVisible ? 'Hide' : 'Show'} Objects</span>
                </button>

                <button
                    onClick={onToggleClusterified}
                    className={'btn border-0 p-2 mx-1 d-flex align-items-center'}

                    data-tooltip-content={!props.onToggleClusterified ? 'Available for Shapes with less than 10000 locations' : ''}
                    data-tooltip-place="left"
                    data-tooltip-id="shape-info-tooltip"
                >
                    <i className={'ti ti-grain fs-4'}></i>
                    <span className={'fs-2 ms-2'}>{clusterified ? 'Disable clustering' : 'Enable clustering'}</span>
                </button>

                <button onClick={onToggleUnion} className={'btn border-0 p-2 mx-1 d-flex align-items-center' + (!props.canEdit ? ' d-none' : '')}>
                    <i className={'ti fs-4 ' + (union ? 'ti-minus' : 'ti-plus')}></i>
                    <span className={'fs-2 ms-2'}>{union ? 'Exclude' : 'Include'} Properties</span>
                </button>
                </>) : ''}

                <button onClick={onEditNotes} className={'btn border-0 p-2 mx-1 d-flex align-items-center' + (!props.canEdit ? ' d-none' : '')}>
                    <i className={'ti ti-edit fs-4'}></i>
                    <span className={'fs-2 ms-2'}>Edit Notes</span>
                </button>

                <button onClick={onTogglePopupTitle} className={'btn border-0 p-2 mx-1 d-flex align-items-center' + (!props.canEdit ? ' d-none' : '')}>
                    <i className={'ti ti-' + (popupTitle ? 'eye-off' : 'eye') + ' fs-4'}></i>
                    <span className={'fs-2 ms-2'}>{popupTitle ? 'Hide the name on map' : 'Show the name on map'}</span>
                </button>

                <hr className={'my-2' + ((!props.canEdit && (!user || !user.id)) ? ' d-none' : '')} />

                <button onClick={onToggleVisible} className={'btn border-0 p-2 mx-1 align-items-center' + (!props.canEdit ? ' d-none' : ' d-flex')}>
                    <i className={'ti ti-' + (visible ? 'eye-off' : 'eye') + ' fs-4'}></i>
                    <span className={'fs-2 ms-2'}>{visible ? 'Hide the Shape' : 'Show the Shape'}</span>
                </button>

                <div className="position-relative">
                    <button onClick={onColorClick} className={'btn border-0 p-2 mx-1 fs-3 align-items-center' + (!props.canEdit ? ' d-none' : ' d-flex')}>
                        <i className={'ti ti-palette fs-4'}></i>
                        <span className={'fs-2 ms-2'}>Recolor Shape</span>

                        <span className="ms-3" style={colorPickerStyle}></span>
                    </button>

                    <ShapeColorPicker
                        visible={colorPickerVisible}
                        color={color ? color : '#388E3C'}
                        onChange={onColorChange}
                        onChangeComplete={onColorChangeComplete}
                    />
                </div>

                <button onClick={onLayerToTopClick} className={'btn border-0 p-2 mx-1 align-items-center' + (!props.canEdit ? ' d-none' : ' d-flex')}>
                    <i className={'ti ti-sort-ascending-2 fs-4'}></i>
                    <span className={'fs-2 ms-2'}>Move to Top</span>
                </button>

                <button onClick={onLayerToBottomClick} className={'btn border-0 p-2 mx-1 align-items-center' + (!props.canEdit ? ' d-none' : ' d-flex')}>
                    <i className={'ti ti-sort-descending-2 fs-4'}></i>
                    <span className={'fs-2 ms-2'}>Move to Bottom</span>
                </button>

                <button onClick={onSaveToFilesClick} className={'btn border-0 p-2 mx-1 align-items-center' + (user && user.id ? ' d-flex' : ' d-none')}>
                    <i className={'ti ti ti-device-floppy fs-4 '}></i>
                    <span className={'fs-2 ms-2'}>Save Shape to My Files</span>
                </button>

                <hr className={'my-2' + (!props.canEdit ? ' d-none' : '')} />

                <button
                    onClick={onConvertShape}
                    className={'btn border-0 p-2 mx-1 d-flex align-items-center' + (!props.canEdit ? ' d-none' : '')}

                    data-tooltip-content={'Properties within the shape will not be included in the mailing count'}
                    data-tooltip-place="left"
                    data-tooltip-id="shape-info-tooltip"
                >
                    <i className={'ti ti-refresh fs-4 text-danger'}></i>
                    <span className={'fs-2 ms-2 text-danger'}>Convert to reference shape</span>
                </button>

                <button onClick={onRemove} className={'btn border-0 p-2 mx-1 d-flex align-items-center' + (!props.canEdit ? ' d-none' : '')}>
                    <i className={'ti ti-trash-x fs-4 text-danger'}></i>
                    <span className={'fs-2 ms-2 text-danger'}>Remove the Shape</span>
                </button>
            </div>

            <Tooltip id="shape-info-tooltip"/>
        </>
    );
}